import { render } from "./ChangeView.vue?vue&type=template&id=b873c7d4&scoped=true"
import script from "./ChangeView.vue?vue&type=script&lang=ts"
export * from "./ChangeView.vue?vue&type=script&lang=ts"

import "./ChangeView.vue?vue&type=style&index=0&id=b873c7d4&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-b873c7d4"

export default script